import React, {Fragment, useEffect, useMemo} from 'react';
import {Button, Col, Divider, Modal, Radio, Row, Tooltip} from "antd";
import {GUTTER_MD, GUTTER_SM, MARGIN_MD, MODAL_WIDTH_LG} from "../../../styles/constants";
import {
    changeDataflowPublishingListDataflowContentConstraintIsAllowed,
    changeVerifyTimePeriodFormat,
    deleteDataflowProductionModalDDBContentConstraints,
    forceDataflowPublishingListDataflowCacheUpdate,
    hideDataflowPublishingListDataflowProductionModal,
    readDataflowProductionModalDataflowContentConstraints,
    setDataflowPublishingListDataflowContentConstraint,
    setDataflowPublishingListDataflowProductionFlag,
    unsetDataflowPublishingListDataflowContentConstraint,
    readDataflowsListDataflows,
    dataflowPublishingResetSuccessfulFlag,
} from "./actions";
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import EnhancedModal from '../../../components/enhanced-modal';
import {getArtefactTripletFromString, getStringFromArtefactTriplet} from "../../../utils/sdmxJson";
import {DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX} from './reducer';
import ReduxContentConstraintDetailModal from "../../../redux-components/redux-content-constraint-modal";
import {
    createContentConstraintDetail,
    editContentConstraintDetail
} from '../../../redux-components/redux-content-constraint-modal/actions';
import {reuseAction} from '../../../utils/reduxReuse';
import { getDataflowDDBContentConstraint } from './utils';
import {
    CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW
} from '../../../redux-components/redux-content-constraint-modal/FilterTab';
import {AUTO_ANNOTATION_DDB_CONTENT_CONSTRAINT_KEY} from '../../../utils/annotations';
import Call from "../../../hocs/call";

const labelStyle = {
    fontSize: 14,
    fontWeight: 500,
    color: "rgba(0,0,0,0.85)"
};

const disabledLabelStyle = {
    fontSize: 14,
    fontWeight: 500,
    color: "rgba(0,0,0,0.35)"
};

const mapStateToProps = state => {
    const endpoints = state.config.nodes;
    const endpointId = state.app.endpointId;
    const node = endpoints.find(endpoint => endpoint.general.id === endpointId);
    return {
        node,
        dataflows: state.scenes.mappingHandler.dataflowPublishing.dataflows,
        dataflowProductionModalDataflowTriplet: state.scenes.mappingHandler.dataflowPublishing.dataflowProductionModalDataflowTriplet,
        dataflowProductionModalTranscodingMode: state.scenes.mappingHandler.dataflowPublishing.dataflowProductionModalTranscodingMode,
        dataflowProductionModalTranscodingContentConstraintTriplet: state.scenes.mappingHandler.dataflowPublishing.dataflowProductionModalTranscodingContentConstraintTriplet,
        isDataflowProductionModalTranscodingContentConstraintListVisible: state.scenes.mappingHandler.dataflowPublishing.isDataflowProductionModalTranscodingContentConstraintListVisible,
        dataflowProductionModalTranscodingContentConstraints: state.scenes.mappingHandler.dataflowPublishing.dataflowProductionModalTranscodingContentConstraints,
        dataflowProductionModalContentConstraintIsAllowed: state.scenes.mappingHandler.dataflowPublishing.dataflowProductionModalContentConstraintIsAllowed,
        verifyTimePeriodFormat: state.scenes.mappingHandler.dataflowPublishing.verifyTimePeriodFormat,
        dataflowProductionModalContentConstraints: state.scenes.mappingHandler.dataflowPublishing.dataflowProductionModalContentConstraints,
        enabledFetchDataflowProductionModalContentConstraints: state.scenes.mappingHandler.dataflowPublishing.enabledFetchDataflowProductionModalContentConstraints,
        contentConstraintDetail: state.scenes.mappingHandler.dataflowPublishing.contentConstraintDetail,
        cubeId: state.scenes.mappingHandler.dataflowPublishing.cubeId,
        successfulAction: state.scenes.mappingHandler.dataflowPublishing.successfulAction,
    }
};

const mapDispatchToProps = dispatch => ({
    onIsAllowedChange: isAllowed => dispatch(changeDataflowPublishingListDataflowContentConstraintIsAllowed(isAllowed)),
    onContentConstraintCreate: (dataflowTriplet, isAllowed) => dispatch(setDataflowPublishingListDataflowContentConstraint(dataflowTriplet, isAllowed)),
    onContentConstraintDelete:
        dataflowTriplet => dispatch(unsetDataflowPublishingListDataflowContentConstraint(dataflowTriplet)),
    onSetProductionFlag: (dataflowTriplet, isProduction) =>
        dispatch(setDataflowPublishingListDataflowProductionFlag(dataflowTriplet, isProduction)),
    onForceCacheUpdate: dataflowTriplet => dispatch(forceDataflowPublishingListDataflowCacheUpdate(dataflowTriplet)),
    onHide: () => dispatch(hideDataflowPublishingListDataflowProductionModal()),
    onChangeVerifyTimePeriodFormat: verifyTimePeriodFormatChecked =>
        dispatch(changeVerifyTimePeriodFormat(verifyTimePeriodFormatChecked)),
    fetchDataflowProductionModalDataflowContentConstraints: dataflowTriplet =>
        dispatch(readDataflowProductionModalDataflowContentConstraints(dataflowTriplet)),
    onCreateDDBConstraintShow: (dataflowTriplet) =>
        dispatch(reuseAction(createContentConstraintDetail(CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW, dataflowTriplet,
            AUTO_ANNOTATION_DDB_CONTENT_CONSTRAINT_KEY), DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX)),
    onUpdateDDBConstraintShow: (contentConstraintTriplet) =>
        dispatch(reuseAction(editContentConstraintDetail(contentConstraintTriplet), DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX)),
    onDDBContentConstraintDelete: (constraintTriplet) => dispatch(deleteDataflowProductionModalDDBContentConstraints(constraintTriplet)),
    fetchDataflows: () => dispatch(readDataflowsListDataflows()),
    resetSuccessfulFlag: () => dispatch(dataflowPublishingResetSuccessfulFlag()),
});


const DataflowPublishingListDataflowProductionModal = ({
                                                           t,
                                                           node,
                                                           dataflows,
                                                           dataflowProductionModalDataflowTriplet,
                                                           dataflowProductionModalContentConstraintIsAllowed,
                                                           dataflowProductionModalContentConstraints,
                                                           enabledFetchDataflowProductionModalContentConstraints,
                                                           contentConstraintDetail,
                                                           onIsAllowedChange,
                                                           onContentConstraintCreate,
                                                           onContentConstraintDelete,
                                                           onSetProductionFlag,
                                                           onForceCacheUpdate,
                                                           onHide,
                                                           fetchDataflowProductionModalDataflowContentConstraints,
                                                           onCreateDDBConstraintShow,
                                                           onUpdateDDBConstraintShow,
                                                           onDDBContentConstraintDelete,
                                                           cubeId,
                                                           fetchDataflows,
                                                           resetSuccessfulFlag,
                                                           successfulAction
                                                       }) => {
    useEffect(() => {
        if (successfulAction) {
            fetchDataflows();
            resetSuccessfulFlag();
        }
    }, [successfulAction]);

    const selectedDataflow = useMemo(() =>
        dataflows && !!dataflowProductionModalDataflowTriplet
            ? dataflows.find(df => df.id === dataflowProductionModalDataflowTriplet.id && df.agencyID === dataflowProductionModalDataflowTriplet.agencyID && df.version === dataflowProductionModalDataflowTriplet.version)
            : null, [dataflows, dataflowProductionModalDataflowTriplet]);

    const hasDDBContentConstraint = useMemo(() => !!getDataflowDDBContentConstraint(selectedDataflow, dataflowProductionModalContentConstraints, node.annotations), [selectedDataflow, dataflowProductionModalContentConstraints, node]);

    const canCreateAutomaticCC = useMemo(() => !!selectedDataflow &&
        selectedDataflow.hasTranscoding &&
        !selectedDataflow.hasContentConstraints, [selectedDataflow]);

    const dataflowHasAutomaticCC = useMemo(() => !!selectedDataflow &&
        selectedDataflow.hasTranscoding &&
        selectedDataflow.hasContentConstraints &&
        !hasDDBContentConstraint, [selectedDataflow, hasDDBContentConstraint]);

    const canCreateDdbCC = useMemo(() => !!selectedDataflow &&
        !selectedDataflow.hasContentConstraints, [selectedDataflow]);

    return (
        <Fragment>
            <Call
                cb={fetchDataflowProductionModalDataflowContentConstraints}
                cbParam={dataflowProductionModalDataflowTriplet}
                disabled={!dataflowProductionModalDataflowTriplet ||
                    !selectedDataflow ||
                    !enabledFetchDataflowProductionModalContentConstraints
                }
            >
                <EnhancedModal
                    visible={!!dataflowProductionModalDataflowTriplet}
                    onCancel={onHide}
                    footer={
                        <Button onClick={onHide}>
                            {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.close.title")}
                        </Button>
                    }
                    width={MODAL_WIDTH_LG}
                    title={t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.title', {
                        id: selectedDataflow ? selectedDataflow.id : ""
                    })}
                >
                    <Fragment>
                        {/* <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                            <Col
                                style={
                                    (canCreateAutomaticCC || dataflowHasAutomaticCC)
                                        ? labelStyle
                                        : disabledLabelStyle
                                }
                            >
                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.label")}
                            </Col>
                        </Row>
                        <Row justify="space-between" type="flex">
                            <Col>
                                <Radio.Group
                                    value={(canCreateAutomaticCC)
                                        ? dataflowProductionModalContentConstraintIsAllowed
                                        : null
                                    }
                                    onChange={({target}) => onIsAllowedChange(target.value)}
                                    size="small"
                                    disabled={!canCreateAutomaticCC}
                                >
                                    <Radio.Button value={true}>
                                        {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.contentConstraintRadio.allowed.title")}
                                    </Radio.Button>
                                    <Radio.Button value={false}>
                                        {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.contentConstraintRadio.actual.title")}
                                    </Radio.Button>
                                </Radio.Group>
                            </Col>
                            <Col>
                                <Row gutter={GUTTER_SM} justify="end" type="flex">
                                    <Col>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.DataflowPublishing.tooltip.createConstraintButton")}>
                                            <Button
                                                disabled={!canCreateAutomaticCC}
                                                size="small"
                                                type="primary"
                                                onClick={
                                                    () => Modal.confirm({
                                                        title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.createButton.confirm.title", {
                                                            id: selectedDataflow ? selectedDataflow.id : ""
                                                        }),
                                                        onOk() {
                                                            onContentConstraintCreate(dataflowProductionModalDataflowTriplet, dataflowProductionModalContentConstraintIsAllowed);
                                                        },
                                                        cancelText: t('commons.buttons.cancel.title')
                                                    })
                                                }
                                            >
                                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.createButton.title")}
                                            </Button>
                                        </Tooltip>

                                    </Col>
                                    <Col>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.DataflowPublishing.tooltip.deleteConstraintButton")}>
                                            <Button
                                                disabled={!dataflowHasAutomaticCC}
                                                size="small"
                                                type="primary"
                                                onClick={
                                                    () => Modal.confirm({
                                                        title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.deleteButton.confirm.title", {
                                                            id: selectedDataflow ? selectedDataflow.id : ""
                                                        }),
                                                        onOk() {
                                                            onContentConstraintDelete(dataflowProductionModalDataflowTriplet);
                                                        },
                                                        cancelText: t('commons.buttons.cancel.title')
                                                    })
                                                }
                                            >
                                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.deleteButton.title")}
                                            </Button>
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Divider/> */}
                        <Row gutter={GUTTER_MD} justify="space-between" type="flex">
                            <Col
                                style={
                                    !!selectedDataflow
                                    // &&
                                    // (
                                    //     selectedDataflow.hasTranscoding ||
                                    //     selectedDataflow.hasContentConstraint
                                    // )
                                        ? labelStyle
                                        : disabledLabelStyle
                                }
                            >
                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.label")}
                            </Col>
                            <Col>
                                <Row gutter={GUTTER_SM} justify="end" type="flex">
                                    <Col>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.DataflowPublishing.tooltip.publishProductionButton")}>
                                            <Button
                                                disabled={
                                                    !selectedDataflow ||
                                                    // (
                                                    //     !selectedDataflow.hasTranscoding &&
                                                    //     !selectedDataflow.hasContentConstraint
                                                    // ) ||
                                                    selectedDataflow.isProduction
                                                }
                                                size="small"
                                                type="primary"
                                                onClick={
                                                    () => Modal.confirm({
                                                        title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.publishButton.confirm.title", {
                                                            id: selectedDataflow ? selectedDataflow.id : ""
                                                        }),
                                                        onOk() {
                                                            onSetProductionFlag(dataflowProductionModalDataflowTriplet, false);
                                                        },
                                                        cancelText: t('commons.buttons.cancel.title')
                                                    })
                                                }
                                            >
                                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.publishButton.title")}
                                            </Button>
                                        </Tooltip>
                                    </Col>
                                    <Col>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.DataflowPublishing.tooltip.removeProductionButton")}>
                                            <Button
                                                disabled={
                                                    !selectedDataflow ||
                                                    // (
                                                    //     !selectedDataflow.hasTranscoding &&
                                                    //     !selectedDataflow.hasContentConstraint
                                                    // ) ||
                                                    !selectedDataflow.isProduction
                                                }
                                                size="small"
                                                type="primary"
                                                onClick={
                                                    () => Modal.confirm({
                                                        title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.removeButton.confirm.title", {
                                                            id: selectedDataflow ? selectedDataflow.id : ""
                                                        }),
                                                        onOk() {
                                                            onSetProductionFlag(dataflowProductionModalDataflowTriplet, true);
                                                        },
                                                        cancelText: t('commons.buttons.cancel.title')
                                                    })
                                                }
                                            >
                                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.removeButton.title")}
                                            </Button>
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Divider/>
                        <Row gutter={GUTTER_MD} justify="space-between" type="flex">
                            <Col
                                style={
                                    (canCreateDdbCC || hasDDBContentConstraint)
                                        ? labelStyle
                                        : disabledLabelStyle
                                }
                            >
                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.label")}
                            </Col>
                            <Col>
                                <Row gutter={GUTTER_SM} justify="end" type="flex">

                                    <Col>
                                        {!hasDDBContentConstraint && (
                                            <Tooltip
                                                title={t("scenes.mappingHandler.DataflowPublishing.tooltip.createCCButton")}>
                                                <Button
                                                    disabled={!canCreateDdbCC}
                                                    size="small"
                                                    type="primary"
                                                    onClick={
                                                        () => Modal.confirm({
                                                            title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.createButton.confirm.title", {
                                                                id: selectedDataflow ? selectedDataflow.id : ""
                                                            }),
                                                            onOk() {
                                                                onCreateDDBConstraintShow(dataflowProductionModalDataflowTriplet);
                                                            },
                                                            cancelText: t('commons.buttons.cancel.title')
                                                        })
                                                    }>
                                                    {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.createButton.title")}
                                                </Button>
                                            </Tooltip>
                                        )}
                                        {hasDDBContentConstraint && (
                                            <Tooltip
                                                title={t("scenes.mappingHandler.DataflowPublishing.tooltip.updateCCButton")}>
                                                <Button
                                                    size="small"
                                                    type="primary"
                                                    onClick={
                                                        () => onUpdateDDBConstraintShow(getArtefactTripletFromString(getStringFromArtefactTriplet(dataflowProductionModalContentConstraints ? dataflowProductionModalContentConstraints[0] : null)))
                                                    }
                                                >
                                                    {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.updateButton.title")}
                                                </Button>
                                            </Tooltip>
                                        )}
                                    </Col>

                                    <Col>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.DataflowPublishing.tooltip.deleteCCButton")}>
                                            <Button
                                                disabled={!hasDDBContentConstraint}
                                                size="small"
                                                type="primary"
                                                onClick={
                                                    () => Modal.confirm({
                                                        title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.deleteButton.confirm.title", {
                                                            id: selectedDataflow ? selectedDataflow.id : ""
                                                        }),
                                                        onOk() {
                                                            onDDBContentConstraintDelete(getArtefactTripletFromString(getStringFromArtefactTriplet(dataflowProductionModalContentConstraints ? dataflowProductionModalContentConstraints[0] : null)));
                                                        },
                                                        cancelText: t('commons.buttons.cancel.title')
                                                    })
                                                }
                                            >
                                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.deleteButton.title")}
                                            </Button>
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>


                        {(node.dataBrowser || {}).enable && (
                            <Fragment>
                                <Divider/>
                                <Row gutter={GUTTER_MD} justify="space-between" type="flex">
                                    <Col style={labelStyle}>
                                        {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.label")}
                                    </Col>
                                    <Col>
                                        <Button
                                            disabled={!selectedDataflow}
                                            size="small"
                                            type="primary"
                                            onClick={
                                                () => Modal.confirm({
                                                    title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.forceCacheUpdateButton.confirm.title", {
                                                        id: selectedDataflow ? selectedDataflow.id : ""
                                                    }),
                                                    onOk() {
                                                        onForceCacheUpdate(dataflowProductionModalDataflowTriplet);
                                                    },
                                                    cancelText: t('commons.buttons.cancel.title')
                                                })
                                            }
                                        >
                                            {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.forceCacheUpdateButton.title")}
                                        </Button>
                                    </Col>
                                </Row>
                            </Fragment>
                        )}
                    </Fragment>
                </EnhancedModal>
            </Call>

            <ReduxContentConstraintDetailModal
                instancePrefix={DATAFLOW_PUBLISHING_CONTENT_CONSTRAINT_PREFIX}
                instanceState={contentConstraintDetail}
                isArtefactSelectorDisabled={true}
                cubeId={cubeId}
                isDdbDataflow={false}
                dataflowId={dataflowProductionModalDataflowTriplet ? `${dataflowProductionModalDataflowTriplet.id}+${dataflowProductionModalDataflowTriplet.agencyID}+${dataflowProductionModalDataflowTriplet.version}` : null}
                isEditEnabledOnlyFromBuilder={true}
            />
        </Fragment>
    );
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    translate(),
)(DataflowPublishingListDataflowProductionModal);
